import React, {useState} from "react";
import {Spin, Tooltip} from "antd";
import {ShopOutlined, UpOutlined, DownOutlined} from "@ant-design/icons";
import {formatMoney2} from "utils/moneyHelper";
import {SubCompanyInvoiceDetail} from "./SubCompanyInvoiceDetail";
import {
    SubCompanyRowWrapper,
    SubCompanyRowHeader,
    SubCompanyIcon,
    SubCompanyFields,
    SubCompanyField,
    SubCompanyTotal,
    SubCompanyRowContent,
    EmptyText
} from "../styles/SubCompanyInvoice.styles";

// Uzun değerler (özellikle ticari ünvan) "…" ile kesildiği için tamamı tooltip'te gösterilir
const Field = ({label, value}) => (
    <SubCompanyField>
        <span className="label">{label}</span>
        <Tooltip title={value} placement="topLeft">
            <span className="value">{value || "-"}</span>
        </Tooltip>
    </SubCompanyField>
);

export const SubCompanyInvoiceRow = ({subCompany, filters, fetchDetail}) => {
    const [expanded, setExpanded] = useState(false);
    const [detail, setDetail] = useState();

    const loadDetail = () => {
        if (detail) return;
        setDetail({loading: true});
        // Detay zaten tek alt firmaya ait; bölge/firma/alt firma filtreleri gönderilmez
        const {startDate, endDate, invoiceStatus} = filters;
        fetchDetail({startDate, endDate, invoiceStatus, subCompanyId: subCompany.subCompanyId})
            .then(data => {
                // Store hata modalını gösterip undefined döner
                setDetail(
                    data ? {loading: false, data} : {loading: false, error: "Detay yüklenemedi"}
                );
            })
            .catch(err => {
                setDetail({loading: false, error: err?.message || "Detay yüklenemedi"});
            });
    };

    const handleToggle = () => {
        if (!expanded) loadDetail();
        setExpanded(prev => !prev);
    };

    const renderContent = () => {
        if (!detail || detail.loading) {
            return (
                <EmptyText>
                    <Spin size="small" />
                </EmptyText>
            );
        }
        if (detail.error) return <EmptyText>{detail.error}</EmptyText>;
        return <SubCompanyInvoiceDetail detail={detail.data} />;
    };

    return (
        <SubCompanyRowWrapper>
            <SubCompanyRowHeader onClick={handleToggle}>
                <SubCompanyIcon>
                    <ShopOutlined />
                </SubCompanyIcon>
                <SubCompanyFields>
                    <Field label="Alt Firma" value={subCompany.subCompanyName} />
                    <Field label="Proje Kodu" value={subCompany.projectCode} />
                    <Field label="Ticari Ünvan" value={subCompany.commercialTitle} />
                    <Field label="Bölge" value={subCompany.zoneName} />
                </SubCompanyFields>
                <SubCompanyTotal>
                    <span className="label">Toplam Fatura Tutarı</span>
                    <span className="amount">
                        {formatMoney2({amount: subCompany.invoiceAmount, currency: "TL"})}
                    </span>
                    <span className="count">({subCompany.invoiceCount || 0} fatura)</span>
                    <span className="arrow">{expanded ? <UpOutlined /> : <DownOutlined />}</span>
                </SubCompanyTotal>
            </SubCompanyRowHeader>
            {expanded && <SubCompanyRowContent>{renderContent()}</SubCompanyRowContent>}
        </SubCompanyRowWrapper>
    );
};
